// developed by Param Partap Singh
import React from 'react'
import Nav from '../Utils/Nav'
import Footer from '../Utils/Footer'
import banner from '../Assets/background2.JPG'
import email from '../Assets/email-police.pdf'
import itaccess from '../Assets/it-access.pdf'
import broadcast from '../Assets/broadcast.pdf'
import cyberone from '../Assets/cyberone.pdf'
import cybertwo from '../Assets/cybertwo.pdf'

export default function Police() {
  return (
    <>
    <Nav/>
    <div className='main-container'>
        <div className="banner">
            <img className="background" src={banner} alt="" />
            <h1 className="main-heading-title">Other IT related Policies</h1>
        </div>
        

        <div className="box-containt">
            <div className="box-n">
                <h2>IIT Ropar Email Policies</h2>
                <ul>
                    <li>IIT Ropar Email Management Policiess set the rules and guidelines regarding email usages at IIT Ropar.</li>
                     <a href={email} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                </ul>    
            </div>
            <div className="box-n">
                <h2>IT Access Policy</h2>
                <ul>
                    <li>IIT Ropar IT policy is the set of all regulations and policies that encourage,regulate the creation, use, storage, access, and communication and dissemination of information.</li>
                    <div className='btn-div'>
                       <a href={itaccess} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                    </div>
                </ul>
            </div>
            <div className="box-n">
                <h2>Posting message to Institute Lists</h2>
                <ul>
                    <li>Differnt broadcast List, Who can post / forward the message? (Posting Permissions) etc.</li>
                    <a href={broadcast} className='btn-n' target='_blank'><button className='btn-p'>Click Here</button></a>
                </ul>
            </div>
            <div className="box-n">
                <h2>National Cyber Crime Reporting Portal</h2>
                <ul>
                    <li style={{marginBlock:"5px"}}>Cyber Safety Manual.<a href={cyberone} style={{textDecoration:"none", color:"red"}} target='_blank'>Click Here</a> </li>
                    <li>Cyber Safety Manual. <a href={cybertwo} style={{textDecoration:"none", color:"red"}} target='_blank'>Click Here</a> </li>
                    <a href="https://cybercrime.gov.in/Default.aspx" className='btn-n' target='_blank'><button className='btn-p'>Visit Website</button></a>
                    
                </ul>
            </div>
            
            
        </div>


    </div>

    <Footer/>
    </>
  )
}
